module.exports = new __parcel__URL__("4.3728eda6.svg").toString();